import script from "./HorizontalLotteryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalLotteryCard.vue?vue&type=script&setup=true&lang=ts"

import "./HorizontalLotteryCard.vue?vue&type=style&index=0&id=35e604cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e604cb"]])

export default __exports__